// Instagram.js
import React from "react";

const Instagram = () => {
  const links = {
    es: "https://www.instagram.com/nisibygiuseppe/",
  };

  return (
    <a
      href={links.es}
      target="_blank"
      rel="noopener noreferrer"
      className="button-styles hover-text"
    >
      <span className="tooltip-text" id="fade">Instagram</span>
      <i className="bi bi-instagram"></i>
    </a>
  );
};

export default Instagram;
